import { FC } from 'react';
import classNames from 'classnames';
import { ButtonPrimary, ButtonProps, Icon } from '@lambdacurry/component-library';
import { facebookAuthURL } from '../../../../util/constants';
import './facebook-auth-button.scss';

export interface FacebookAuthButtonProps extends ButtonProps {
  redirect: string;
}

export const FacebookAuthButton: FC<FacebookAuthButtonProps> = ({ className, children, href, redirect, ...props }) => {
  const facebookAuthLink = facebookAuthURL(redirect);

  return (
    <ButtonPrimary
      className={classNames('facebook-auth-button text-sm', className)}
      {...props}
      as={buttonProps => (
        <a href={facebookAuthLink} {...buttonProps}>
          <span className="flex items-center relative gap-2">
            <Icon name="facebookSquare" />
            {children}
          </span>
        </a>
      )}
    />
  );
};
